import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4zM10 15l-3.89-3.89v2.55H5V9.22h4.44v1.11H6.89l3.11 3.1 4.22-4.22.78.79-5 5z"
}), 'MissedVideoCallSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MissedVideoCallSharp.js
// module id = 4849
// module chunks = 2